export default __webpack_public_path__ + "static/media/statisticsIcon.4bd343b8.svg";